import React, { useState } from "react";
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { observer } from 'mobx-react-lite';
import { MultiSelect } from 'primereact/multiselect';

const groupedItemTemplate = (option: any) => {
    return (
        <div className="flex align-items-center">
            <div>{option.label}</div>
        </div>
    );
};

// Custom item template for products
const productItemTemplate = (product: any) => {
    return (
        <div className="flex align-items-center">
            <span>{product.label}</span>
            {product.value.chargeable && (
                <i
                    className="pi pi-euro"
                    style={{ fontSize: '0.6rem', color: '#E6007E', marginLeft: '8px' }}
                    title="Kostenpflichtig"
                ></i>
            )}
        </div>
    );
};


const AddProductDialog = observer(({ store }: { store: any }) => {
    const [selectedProducts, setSelectedProducts] = useState<any[]>([]);

    // Optionen für das Multi-Dropdown
    let productOptions = [
        {
            label: 'Zugewiesene Produkte',
            items: store.addProductAssignedFiltered.map((product: any) => ({
                label: product.name,
                value: product
            }))
        },
        {
            label: 'Nicht zugewiesene Produkte',
            items: store.addProductAvailableFiltered.map((product: any) => ({
                label: product.name,
                value: product
            }))
        }
    ];

    productOptions = productOptions.filter((group: any) => group.items.length > 0); // Filtere leere Gruppen heraus

    const handleAddProducts = async () => {
        if (selectedProducts.length > 0) {
            store.addProductsToOrder(selectedProducts);
            setSelectedProducts([]); // Auswahl zurücksetzen
            store.closeAddProductDialog(); // Dialog schließen
        }
    };

    return (
        <Dialog
            visible={store.productDialog}
            header="Produkte hinzufügen"
            onHide={() => {
                store.closeAddProductDialog();
                setSelectedProducts([]);
            }}
            style={{ width: '40rem' }}
        >
            <div className="p-fluid">
                {productOptions.length ? (
                    <>
                        <h4>Produkte auswählen</h4>
                        <MultiSelect
                            filter
                            value={selectedProducts}
                            options={productOptions}
                            onChange={(e) => setSelectedProducts(e.value)}
                            placeholder="Produkte auswählen"
                            display="chip"
                            style={{ width: '100%', marginBottom: '1rem' }}
                            optionLabel="label"
                            optionGroupLabel="label"
                            optionGroupChildren="items"
                            optionGroupTemplate={groupedItemTemplate}
                            itemTemplate={productItemTemplate} // Custom item template
                        />
                        <Button
                            label="Hinzufügen"
                            icon="pi pi-plus"
                            onClick={handleAddProducts}
                            disabled={selectedProducts.length === 0}
                            className="p-button-success"
                        />
                    </>
                ) : (
                    <>
                        Keine Produkte verfügbar
                    </>
                )}
            </div>
        </Dialog>
    );
});

export default AddProductDialog;